module.exports = __webpack_public_path__ + "svg/start.f69b4d49fe24827471cc1f07f4090a01.svg";